import PropTypes from "prop-types";
import { createContext, useEffect, useReducer, useCallback } from "react";
// utils
import axios from "../utils/axios";
//
import { isValidToken, setSession } from "./utils";
import { setSchoolInfo } from "../redux/slices/school";
import { getSchoolInfo } from "../redux/services/school_service";

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  isRegister: false,
  user: null,
};

const reducer = (state, action) => {
  if (action.type === "INITIAL") {
    return {
      isInitialized: true,
      isAuthenticated: action.payload.isAuthenticated,
      isRegister: false,
      user: action.payload.user,
    };
  }
  if (action.type === "LOGIN") {
    return {
      ...state,
      isAuthenticated: true,
      isRegister: true,
      email: action.payload.email,
      firstName: action.payload.firstName,
      lastName: action.payload.lastName,
      phoneNumber: action.payload.phoneNumber,
      profilePictureUrl: action.payload.profilePictureUrl,
      id: action.payload.id,
    };
  }
  if (action.type === "REGISTER") {
    return {
      ...state,
      isAuthenticated: false,
      isRegister: true,
      user: null,
    };
  }
  if (action.type === "LOGOUT") {
    return {
      ...state,
      isAuthenticated: false,
      user: null,
    };
  }

  return state;
};

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    try {
      const accessToken =
        typeof window !== "undefined"
          ? localStorage.getItem("accessToken")
          : "";

      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);

        /*   const response = await axios.get("/api/User/IsAuthenticated");

        const { user } = response.data.user;

        dispatch({
          type: "INITIAL",
          payload: {
            isAuthenticated: true,
            user,
          },
        });*/
      } else {
        dispatch({
          type: "INITIAL",
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: "INITIAL",
        payload: {
          isAuthenticated: false,
          user: null,
        },
      });
    }
  }, []);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // LOGIN
  const login = async (data) => {
    const response = await axios.post("/api/controlLogin", data);
    setSession(response.data.access_token);

    dispatch({
      type: "LOGIN",
      payload: {
        email: response.data.email,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        phoneNumber: response.data.phoneNumber,
        profilePictureUrl: response.data.profilePictureUrl,
        gender: response.data.gender,
        id: response.data.id,
      },
    });

    if (
      response.status === 200 ||
      response.message === "Login Successful" ||
      response.message === "تم تسجيل الدخول بنجاح"
    ) {
      localStorage.setItem(
        "user",
        JSON.stringify({
          id: response.data.user.id,
          username: response.data.user.username,
          type: response.data.user.type,
          schoolId: response.data.user.school_id,
          parentId: response.data.user.parent_data_id,
          createdAt: response.data.user.created_at,
          updatedAt: response.data.user.updated_at,
        })
      );

      if (
        response.data.user.type === "secretary" ||
        response.data.user.type === "manager"
      ) {
        //    dispatch(setSchoolInfo({ schoolInfo: response.data.user.school_id }));
        localStorage.setItem("school_id", response.data.user.school_id);
        localStorage.setItem(
          "AuthenticatedProvider",
          response.data.user.type === "secretary" ? "secretaries" : "managers"
        );

        window.location.href = "/dashboard";
      } else {
        window.location.href = "/manager";
        localStorage.setItem("AuthenticatedProvider", "controls");
      }
    }
  };

  // REGISTER
  const register = async (data, email) => {
    localStorage.removeItem("email");
    const response = await axios.post("/api/FacilityAdmin/SignUp", data, {
      headers: { "content-type": "multipart/form-data" },
    });

    dispatch({
      type: "REGISTER",
      payload: {
        isRegister: true,
        user: null,
      },
    });
    if (response.status === 200 && response.message === "Success") {
      localStorage.setItem("email", email);
    }
  };

  //Confirm Email
  const confirmEmail = async (data) => {
    console.log(data);
    const response = await axios.post("/api/FacilityAdmin/ConfirmEmail", data);

    setSession(response.data.token);

    dispatch({
      type: "LOGIN",
      payload: {
        email: response.data.email,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        phoneNumber: response.data.phoneNumber,
        profilePictureUrl: response.data.profilePictureUrl,
        id: response.data.id,
      },
    });
  };

  // LOGOUT
  const logout = async () => {
   
  //  const response = await axios.post("/api/controlLogout");
    /* if (
      response.message === "Logout Successful" ||
      response.message === "تم تسجيل الخروج بنجاح"
    ) {
      localStorage.clear();
      setSession(null);
      dispatch({
        type: "LOGOUT",
      });
      window.location.href = "/";
    }*/
    localStorage.clear();
       window.location.href = "/";
    setSession(null);
    dispatch({
      type: "LOGOUT",
    });
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: "jwt",
        register,
        confirmEmail,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
